import { Outlet } from 'react-router-dom';
import { Header } from '../../shared/Header.jsx';

export const LandingLayout = () => {
  return (
    <>
      <div className="w-full h-full px-[80px] flex flex-col items-center gap-[20px]">
        <Header />
        <Outlet />
      </div>
    </>
  );
};
